import { l } from '@manychat/manyui'

import { CheckoutTypes } from 'common/billing/constants/checkoutTypes'

export const STRIPE_CHECKOUT_POST_UPGRADE_MESSAGES = {
  [CheckoutTypes.UPGRADE_DATA]: l.translate('Billing Credentials were updated successfully'),
  [CheckoutTypes.TRIAL]: l.translate('Trial activated!'),
  [CheckoutTypes.UPGRADE_TO_PRO]: l.translate('Payment was successful'),
}
